import React from 'react';
import { Box, Inscription } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { convertSecondsToMinutes } from '@/utils/modifiers/convertSecondsToMinutes';

import useResendVerificationForContact from '../hooks/useResendVerificationForContact';

import ContactVerificationHint from './ContactVerificationHint';

interface Props {
  emailNode: React.ReactNode;
  isEmailVerified?: boolean;
  contactId?: number;
  email?: string;
};

const ResendVerificationHint: React.FC<Props> = ({ emailNode, isEmailVerified, contactId, email }) => {
  const { handleResend, isDisabled, remainingTime } = useResendVerificationForContact({
    valueKey: toString(contactId),
    contactId: toString(contactId),
    value: toString(email),
  });

  return (
    <Box data-testId="resend-verification-field-wrapper">
      <Box direction="row" align="center">
        {emailNode}
        <ContactVerificationHint isVerified={isEmailVerified} />
      </Box>

      <Inscription
        data-testId="resend-verification-code"
        color={isDisabled ? 'textDisabled' : 'textAccent'}
        {...isDisabled
          ? {}
          : { onClick: () => void handleResend(), cursor: 'pointer' }
        }
      >
        {'Resend verification '}
        {remainingTime > 0 && `(${convertSecondsToMinutes(remainingTime)})`}
      </Inscription>
    </Box>
  );
};

export default ResendVerificationHint;
